import SkillsCarousel from './SkillsCarousel';

const govAndPlatformSkills: { label: string; colour?: string }[] = [
  { label: 'GOV.UK Notify' },
  { label: 'GOV.UK Design System' },
  { label: 'GOV.UK Pay' },
  { label: 'WCAG 2.1 AA', colour: 'turquoise' },
  { label: 'WCAG 2.2 AAA', colour: 'teal' },
  { label: 'LocalGov Drupal', colour: 'grey' },
  { label: 'Civica', colour: 'grey' },
  { label: 'Firmstep', colour: 'grey' },
  { label: 'Matomo Analytics', colour: 'green' },
  { label: 'PRINCE2', colour: 'purple' },
  { label: 'Agile & Scrum', colour: 'pink' },
  { label: 'GDPR', colour: 'red' },
  { label: 'ITIL', colour: 'orange' },
  { label: 'Microsoft Azure' },
  { label: 'Power BI', colour: 'yellow' },
  { label: 'Power Apps', colour: 'yellow' },
  { label: 'Microsoft 365', colour: 'grey' },
  { label: 'SQL Server', colour: 'grey' },
];

export default function Skills() {
  return (
    <div id="skills" className="govuk-width-container govuk-!-padding-top-8 govuk-!-padding-bottom-8">
      <h2 className="govuk-heading-l">Skills & expertise</h2>

      <h3 className="govuk-heading-m govuk-!-margin-top-6">Tools & technologies</h3>
      <p className="govuk-body">Use the arrows to browse, or scroll horizontally.</p>
      <SkillsCarousel />

      <h3 className="govuk-heading-m govuk-!-margin-top-6">Public sector standards & platforms</h3>
      <p className="govuk-body-s" style={{ color: '#505a5f' }}>
        Not all of these have distinct logos to license or reproduce, so they're listed as tags.
      </p>
      <p>
        {govAndPlatformSkills.map((s) => (
          <strong
            key={s.label}
            className={`govuk-tag${s.colour ? ` govuk-tag--${s.colour}` : ''} govuk-!-margin-right-1 govuk-!-margin-bottom-1`}
          >
            {s.label}
          </strong>
        ))}
      </p>

      <h3 className="govuk-heading-m govuk-!-margin-top-6">Languages</h3>
      <p className="govuk-body">
        Gujarati (Native/Bilingual) &middot; English (Full Professional) &middot;
        Spanish (Professional Working) &middot; Hindi (Full Professional)
      </p>
    </div>
  );
}
